

import React, { useEffect } from 'react';
import './Privacy.css';
 import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);
  return (
    <>
    <Navigation />  
    <div className="privacy-policy-container">
      <h1>Acceptable Use Policy for Messaging</h1>

      <p>
        The following content and behaviours are not permitted using Unified Voice:
      </p>

      <h2>Sending Unsolicited Messages</h2>
      <p>
        SMS recipients must have explicitly opted in to receiving messages from you. The opt-in process must be clearly
        explained to customers in a manner in which the recipient was aware they would receive SMS messages.
      </p>
      <p>The following do not qualify as valid opt-ins:</p>
      <ul>
        <li>
          Collecting the recipient's phone number for another purpose (such as for validating payments) but then sending
          messages to that recipient
        </li>
        <li>
          Purchasing, borrowing, renting, or otherwise obtaining the recipient's phone number or a lead list from a
          third party
        </li>
        <li>
          Having the customer opt in for a transactional message (such as message on delivery of a package) and then
          subscribing them to a recurring campaign
        </li>
      </ul>
      <p>Unified Voice reserves the right to request proof of opt-in at any time.</p>

      <h2>Sending Messages Containing Inappropriate Content</h2>
      <p>The following types of content are explicitly prohibited:</p>
      <ul>
        <li>Sexual or pornographic</li>
        <li>Considered abusive or harassing</li>
        <li>Firearms</li>
        <li>Alcohol, tobacco or illegal drugs</li>
        <li>Loans, loan forgiveness, credit repair, debt collection or tax-related content</li>
        <li>Gambling</li>
        <li>Investment opportunities</li>
        <li>Unsolicited real estate enquiries such as ‘We Buy Homes’</li>
        <li>Multilevel marketing</li>
        <li>
          Persistent receiving or sending of one-time passcodes from or on behalf of other service providers.
        </li>
      </ul>

      <h2>Not Adhering to Unsubscribe Requests</h2>
      <p>
        Recipients may choose to unsubscribe from any further messages from you by sending stop words such as STOP or
        UNSUBSCRIBE. These messages will be delivered to you automatically via a webhook. Upon receipt, you have up to
        24 hours to remove the recipient from your list.
      </p>

      <h2>Sending a High Frequency of Messages to a Recipient</h2>
      <p>
        You may not send more than 10 messages to a recipient in any 24-hour period unless the following conditions are
        met:
      </p>
      <ul>
        <li>The recipient has engaged in two-way communication over SMS such as for a chat feature</li>
        <li>The customer has explicitly opted in to receiving frequent messages</li>
      </ul>

      <h2>Misrepresenting Your Identity (spoofing)</h2>
      <p>
        You may not represent or identify yourself as another individual or business in any way. More specifically, you
        may not use the message body or the phone number in a way that would lead the recipient to believe you are
        another individual or business.
      </p>

      <h2>Engaging in Fraud or Phishing For Information</h2>
      <p>
        Sending messages with fraudulent information or phishing to get confidential information from a recipient is
        explicitly prohibited.
      </p>
    </div>
    <Scrolltop />
    <WhatsAppChatButton />
    <Footer />
    </>
  );
};

export default Privacy;
